<template>
    <div class="flex w-full cursor-pointer items-center overflow-hidden rounded-md" @click="btnClickHandler">
        <UButton
            class="w-full justify-between overflow-hidden whitespace-nowrap rounded-none"
            :label="link.label ? link.label : 'Button'"
            :trailing="true"
            size="xl"
            color="neutral"
            variant="ghost"
            :padded="false"
            :ui="btnStyling"
            :to="navigateToLink"
        >
            <template #trailing>
                <div class="relative flex h-full items-center justify-end gap-4 px-3">
                    <UIcon
                        v-if="link.subItems?.length"
                        class="flex w-5 h-5 text-navigation-icon transition-transform"
                        :class="{ 'rotate-180': subMenuHandler }"
                        name="i-heroicons-solid:chevron-down"
                    />
                </div>
            </template>
        </UButton>
    </div>
</template>

<script setup lang="ts">
import type { Navigation } from '~/types/api/navigation'

interface NavLink extends Navigation {
    isActive?: boolean
}

interface Props {
    link: NavLink
    unfoldSubItem?: boolean
}

const {
    link,
    unfoldSubItem = false,
} = defineProps<Props>()

const expandSubitem = inject<Ref<boolean>>('navItemExpandSubitem', ref(false))
const useIsNavClosed = useState('isNavClosed')

const subMenuHandler = computed(() => unfoldSubItem || expandSubitem.value)

const btnColors = computed(() => {
    const active = link.isActive ? ' !text-text-primary' : ''
    return `text-navigation-icon group-hover/sideNav:text-navigation-icon-hover${active}`
})

const btnStyling = computed(() => ({
    color: { black: { ghost: btnColors.value } },
    icon: { size: { xl: 'w-7 h-7' } },
}))

const navigateToLink = computed(() => {
    if (link.subItems?.length || !link.to) return undefined
    return link.to
})

const btnClickHandler = async () => {
    if (link.subItems?.length) {
        if (useIsNavClosed.value) {
            useIsNavClosed.value = false
            expandSubitem.value = true
            return
        }

        expandSubitem.value = !expandSubitem.value
        return
    }

    if (link.to) {
        useIsNavClosed.value = true
        await navigateTo(link.to)
    }
}
</script>
